export default {
    id: "paintings",
    titleKey: {
      zh: "绘画作品",
      en: "Paintings"
    },
    descriptionKey: {
      zh: "这里存放我的绘画创作。",
      en: "A collection of my paintings."
    },
    items: [
      {
        id: "p1",
        titleKey: { zh: "《回归》", en: "'Return'" },
        image: require('@/assets/images/paintings/DRAW_20241022_return.webp'),
        descriptionKey: { zh: "2024年生日绘，致敬心灵杀手2。", en: "2024 Birthday Drawing, Tribute to Alan Wake 2." },
        date: { year: 2024 },
        medium: { zh: "数字绘画", en: "Digital Painting"}
      }
    ]
  }